<template>
  <div>
    <div class="contentMenu" :class="{marginCenter:centerBtn}">
      <p v-if="centerBtn" class="back" @click="back">返回上一页</p>
      <div style="height:5px"></div>
      <h4 class="marginl10">创建案件并启动救援</h4>
      <div>
        <table class="padding-bj pad-0-10" cellpadding="5">
          <tr>
            <td>
              <span>案件类型：</span>
              <el-select v-model="reportcase.subServiceType" placeholder="请选择" class="marginl10" style='width: 300px;'>
                <el-option v-for="item in subServiceTypeSel" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <span class="must">*</span>
            </td>
            <td>
              <template v-if="this.$route.name == 'newstar1'">
                <!-- <el-button type="primary" size="small" @click="dialogFormVisible2=true">查看聊天记录</el-button> -->
                <el-button type="primary" size="small" @click="dialogFormVisible4=true">查看案件详细进度</el-button>
              </template>

            </td>
          </tr>
        </table>
      </div>
      <!--A、案件基本信息-->
      <h5 class="marginl10 margint-10">A、案件基本信息
        <span class="padding-20 span_node">案件编号：{{reportcase.caseNo}}</span>
          <!-- <el-button style="float: right;margin-right: 60px;" type="primary" @click="draft">草稿</el-button> -->
        <span v-if="this.$route.name == 'newstar'" class="padding-20 lisave span_node" @click="centerDialogVisible=true">创建关联案件</span>
      </h5>
      <div class="marginl10">
        <div>
          <table class="padding-bj pad-0-10" cellpadding="5">
            <tr>
              <td>
                报案时间:
                <el-date-picker type="datetime" placeholder="选择日期" v-model="reportcase.reportTs" class="marginl10"></el-date-picker>
                &nbsp;
                <span class="must">*</span>
              </td>
              <td>
                报案人:
                <el-input placeholder="请输入报案者姓名" v-model="reportcase.reportUser" class="marginl10"></el-input>
                &nbsp;
                <span class="must">*</span>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>
                报案电话:
                <el-input placeholder="请输入报案者联系电话" v-model="reportcase.reporterContact" class="marginl10"></el-input>
                &nbsp;
                <span class="must">*</span>
              </td>
              <td colspan="2">
                出险时间:
                <el-date-picker type="datetime" placeholder="出险时间" v-model="reportcase.incidentTs" class="marginl10"></el-date-picker>
                &nbsp;
                <span class="must">*</span>
              </td>
            </tr>

            <tr>
              <td>
                案件信息来源:
                <el-select v-model="reportcase.caseSrc" placeholder="请选择" class="marginl10" :disabled="ifyjjy">
                  <el-option v-for="item in casesrclst" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <span class="must">*</span>
              </td>
              <td>
                来源说明:
                <!-- <el-input placeholder="请输入来源说明" v-model="reportcase.caseSrcDesc" class="marginl10"></el-input> -->
                <changeLanguage :changeText='reportcase.caseSrcDesc' style='display: inline-block;' class="marginl10"
                  v-model='reportcase.caseSrcDesc'></changeLanguage>
                &nbsp;
                <span class="must">*</span>
              </td>
            </tr>
            <tr>
              <td>
                渠道：
                <el-select v-model="reportcase.channel" placeholder="旅责险" class="marginl10" style="width:20%">
                  <el-option v-for="item in chanelSelect" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <span class="must">*</span>
                <!-- <el-input style="width:30%" placeholder="" class="marginl10"></el-input> -->
              </td>
            </tr>
            <tr v-if="reportcase.channel == '旅责险'">
              <td>
                旅行社名称：
                <el-select v-model="reportcase.travelId" placeholder="请选择旅行社" class="marginl10" filterable>
                  <el-option v-for="(item,index) in restaurants" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <span class="must">*</span>
                <!-- <el-button type="primary" size="small" @click="queryTravelAgency()">查询旅行社</el-button> -->
              </td>
            </tr>
            <tr v-if="reportcase.channel == '其他'">
              <td>
                渠道名称：
                <el-input v-model="reportcase.channel1" placeholder="请输入渠道"></el-input>
                <span class="must">*</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <!--B、出险信息-->
      <h5 class="marginl10">B、出险信息</h5>
      <div class="marginl10">
        <table class="padding-bj pad-0-10" cellpadding="5">
          <tr>
            <!-- <td><span>发起人：</span><span>{{llrName.name}}</span></td> -->
            <!-- <td><span>发起人手机号：</span><span>13256536956</span></td> -->
            <td><span>大救星ID：</span><span>{{reportcase.djxId}}</span></td>
          </tr>
          <tr>
            <td>
              <span class="">出险人姓名:</span>
              <el-input placeholder="请输入出险人姓名" v-model="reportcase.victimName" class="marginl10"></el-input>
              &nbsp;
              <span class="must">*</span>
            </td>
            <td>
              <span class="">性别:</span>
              <el-select v-model="reportcase.gender" @change="genderselect" placeholder="请选择" class="marginl10 w100">
                <el-option v-for="item in genderlst" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              &nbsp;
              <span class="must">*</span>
            </td>
            <td></td>
          </tr>
          <tr>
            手机号：
            <el-input placeholder="请输入手机号" v-model="nationalMobile" class="marginl10"></el-input> <!-- v-model -->
            <span class="must">*</span>
            <el-button type="primary" size="small" @click="queryPhone()" style="margin-right:20px;">查询</el-button>
            <el-button type="primary" size="small" @click="dialogFormVisible3=true">创建大救星账号</el-button>
          </tr>
          <tr>
            <td>
              <span class="">出险人证件:</span>
              <el-input placeholder="请输入出险人证件" v-model="reportcase.idNo" class="marginl10" @change="idnochange"></el-input>
              &nbsp;
              <span class="must">*</span>
              &nbsp;
              <el-button type="primary" size="small" @click="B_queryBaodanClick()">查询保单</el-button>
            </td>
            <td>
              <span class="">保单号码:</span>
              <el-input placeholder="请输入保单号码" v-model="reportcase.insurancePolicyNo" class="marginl10"></el-input>
              <el-button type="primary" size="small" @click="showinsurance()">保单详情</el-button>
            </td>
            <td></td>
          </tr>
          <tr>
            <td colspan="2">
              <span class="">所属保险公司:</span>
              <el-select v-model="reportcase.insuranceCompanyId" @change='suoshuFun' class="marginl10 w213" placeholder="请选择保险公司"
                filterable>
                <el-option v-if='item.insti.name' v-for="item in companies" :key="item.id" :label="item.insti.name"
                  :value="item.insti.id"></el-option>
              </el-select>
              <span class="must">*</span>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <span class="">出险地:</span>
              <el-select v-model="reportcase.siteabroadExpr" @change="caseabroad(1)" class="w75" placeholder="境内">
                <el-option v-for="item in abroad" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <span class="must" v-if="reportcase.siteabroadExpr=='境外'">*</span>
              <el-select v-model="reportcase.nation" v-if="reportcase.siteabroadExpr=='境外'" @change="loadcounties('',false,1)"
                class="w120" placeholder="请选择国家" filterable>
                <el-option v-for="item in countries" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>

              <span class="must">*</span>
              <el-select v-model="reportcase.city" class="w130" placeholder="请选择地区" filterable>
                <el-option v-for="item in counties" :key="item.cityCode" :label="item.cityName" :value="item.cityCode"></el-option>
              </el-select>

              <span class="must">*</span>
              <!-- <el-input placeholder="其他详细地址" v-model="reportcase.addr" class="w303"></el-input> -->
              <changeLanguage ref=changeLanguage :changeText='reportcase.addr' class="w303" v-model='reportcase.addr'></changeLanguage>
              <span class="must">*</span>
             <div class="w303">
               <el-input style="width:200px" v-model="Longitudeandlatitude"  @blur="Longitudeandlatitudeblur"></el-input>
              <span style="min-width: 240px;display: inline-block;">经度：{{reportcase.latitude}}；纬度：{{reportcase.longitude}}</span>
              <div>
                 <a href="https://api.map.baidu.com/lbsapi/getpoint/index.html" target="_blank">获取当前GPS<span class="must">*</span> </a>
              </div>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <span class="">事故类型:</span>
              <el-select v-model="reportcase.accidentType" placeholder="请选择">
                <el-option v-for="item in accidentTypes" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              &nbsp;
              <span class="must">*</span>
            </td>
            <td></td>
          </tr>
          <tr>
            <td colspan='2'>
              <span class="back-wc">受伤部位:</span>
              <changeLanguage :changeText='reportcase.injuredPart' class="w88100" v-model='reportcase.injuredPart'></changeLanguage>
              <span class="must">*</span>
            </td>
          </tr>

        </table>
      </div>
      <div class="p1026 h50">
        <span class="back-wc">天气灾害:</span>
        <el-radio-group v-model="reportcase.weatherIncident" size="mini">
          <el-radio :label="1" border>是</el-radio>
          <el-radio :label="2" border>否</el-radio>
        </el-radio-group>
      </div>
      <div class="p1026">
        <span class="back-wc" style="vertical-align: top;">事故经过:</span>
        <!-- <el-input type="textarea" placeholder="请输入内容" v-model="reportcase.incidentDesc" class="w88100"></el-input> -->
        <changeLanguage class="w88100" :changeText='reportcase.incidentDesc' v-model='reportcase.incidentDesc'></changeLanguage>

        <span class="must">*</span>
      </div>
      <!--保险公司联络人判断条件  v-if="$route.name == 'callCase' || $route.name == 'callCase1'" -->
      <!--C、保险公司联络人-->
      <div class="c" v-if="!initialCaseIdBtn">
        <h5 class="marginl10">C、保险公司联络人 <small style="color: red;">若此案件为保险公司替用户报案，请务必获取后续对接人联系方式</small></h5>
        <ul class="lianluo">
          <li>
            <span class="">保险公司对接人:</span>
            <el-input placeholder="请输入保险公司对接人" v-model="callCase.contactName" class="marginl10"></el-input>
          </li>
          <li>
            <span class="">对接人联系方式:</span>
            <el-input placeholder="请输入对接人联系方式" v-model="callCase.contactNo" class="marginl10"></el-input>
          </li>
        </ul>
        <ul class="lianluo">
          <li>
            <span class="">&nbsp;&nbsp;&nbsp;保险公司名称:</span>
            <el-input placeholder="请输入保险公司对接人" v-model="callCase.company" class="marginl10"></el-input>
          </li>
        </ul>
        <div class="p1026">
          <span class="back-wc" style="vertical-align: top;">其他信息:</span>
          <el-input type="textarea" placeholder="请输入内容" v-model="callCase.description" class="w88100"></el-input>
        </div>
      </div>
      <!--D、添加联络人-->
      <div class="d" v-if="this.$route.name == 'newstar' || formRoute == 'creatCase'">
        <h5 class="marginl10">D、添加联络人
          <span class="contactAddStyle" @click="addContacterDialogVisible=true">添加新注册的联络人</span>
          <span class="contactAddStyle" @click="addSubUserFun">添加</span>
        </h5>
        <el-table empty-text="暂无数据" :data="cooperaterDataList" border>
          <el-table-column prop="name" label="国内协调人">
          </el-table-column>
          <el-table-column prop="name" label="所属分公司">
            <template>
              <span>本公司</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.$index)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <ruserId v-if="this.$route.name == 'newstar' || formRoute == 'creatCase'" ref='ruserId'></ruserId>
      <!--E、星使派单信息-->
      <div class="e">
        <h5 class="marginl10">E、星使派单信息</h5>
        <table class="padding-bj pad-0-10" cellpadding="5">
          <tr>
            <td>
              开始时间：
              <el-date-picker type="datetime" placeholder="开始时间" v-model="reportcase.xsStart" class="marginl10"></el-date-picker>
            </td>
            <td>
              结束时间:
              <el-date-picker type="datetime" placeholder="结束时间" v-model="reportcase.xsEnd" class="marginl10"></el-date-picker>
            </td>
            <td>
              服务时长：
              <el-input placeholder="服务时长" v-model.number="reportcase.xsDuration" class="marginl10"></el-input>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <span class="">汇合地点:</span>
              <el-select v-model="reportcase.addr1" @change="caseabroad(2)" class="w75" placeholder="境内">
                <el-option v-for="item in abroad" :key="item" :label="item" :value="item"></el-option>
              </el-select>
              <!-- <span class="must" v-if="reportcase.addr1=='境外'">*</span> -->
              <el-select v-model="reportcase.rCountryCode" v-if="reportcase.addr1=='境外'" @change="loadcounties('',false,2)"
                class="w120" placeholder="请选择国家" filterable>
                <el-option v-for="item in countries" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-select v-model="reportcase.rCity" class="w130" placeholder="请选择地区" filterable>
                <el-option v-for="item in counties1" :key="item.cityCode" :label="item.cityName" :value="item.cityCode"></el-option>
              </el-select>

              <!-- <el-input placeholder="其他详细地址" v-model="reportcase.addr" class="w303"></el-input> -->
              <changeLanguage ref=changeLanguage :changeText='reportcase.rendezvous' class="w303" v-model='reportcase.rendezvous'></changeLanguage>

           <div class="w303">
               <el-input style="width:200px" v-model="Longitudeandlatitude"  @blur="Longitudeandlatitudeblur"></el-input>
              <span style="min-width: 240px;display: inline-block;">经度：{{reportcase.latitude}}；纬度：{{reportcase.longitude}}</span>
              <div>
                 <a href="https://api.map.baidu.com/lbsapi/getpoint/index.html" target="_blank">获取当前GPS<span class="must">*</span> </a>
              </div>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            汇合地点联系方式:
            <el-input placeholder="联系方式" v-model="reportcase.rContact" class="marginl10"></el-input>
            &nbsp;
          </tr>
        </table>
      </div>
      <!--F、客服救助医院信息-->
      <div class="f">
        <h5 class="marginl10">F、客服救助医院信息</h5>
        <table class="padding-bj pad-0-10" cellpadding="5">
          <tr>
            <td>救助医院名称:<el-input placeholder="请输入医院" class="marginl10" v-model="reportcase.hospital"></el-input>
            </td>
            <td>主治医生姓名:<el-input placeholder="请输入医生姓名" class="marginl10" v-model="reportcase.attendingDoctor"></el-input>
            </td>
            <td>医生联系方式:<el-input placeholder="请输入医生联系方式" class="marginl10" v-model="reportcase.adContact"></el-input>
            </td>
          </tr>
        </table>
        <template v-if="formRoute != 'monitoring'">
          <div class="uploadStyle">
            <span>跟地接社工作人员照片:</span>
            <el-upload action="gongzuorenyuanimageUrl" class="avatar-uploader" :show-file-list="false" :http-request="requestFile"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="gongzuorenyuanimageUrl" :src="gongzuorenyuanimageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div class="uploadStyle">
            <span>患者家属照片:</span>
            <el-upload class="avatar-uploader" action="jiashuimageUrl" :http-request="requestFile" :show-file-list="false"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="jiashuimageUrl" :src="jiashuimageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div class="uploadStyle">
            <span>所在医疗机构及科室的照片:</span>
            <el-upload class="avatar-uploader" action="yiliaoimageUrl" :show-file-list="false" :http-request="requestFile"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="yiliaoimageUrl" :src="yiliaoimageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
          <div class="uploadStyle">
            <span>医疗证明及其他相关材料照片:</span>
            <el-upload class="avatar-uploader" action="cailiaoimageUrl" :show-file-list="false" :http-request="requestFile"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="cailiaoimageUrl" :src="cailiaoimageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </template>
      </div>
      <!--G、服务简报-->
      <div class="g serviceBrief" v-if="false">
        <h5 class="marginl10">G、服务简报 <small style="color: red;">此信息由星使填写</small></h5>
        <ul>
          <li>
            <h4>2019/04/05 <small>服务简报</small></h4>
            <p>今天提供的服务内容是协助客户就医问诊，家属成员包括客户的女儿和妻子及旅行社的需求，服务总时长为5个小时左右</p>
          </li>
        </ul>
      </div>

      <div style="text-align: center;margin-top:20px;padding-bottom:20px;">
        <div v-if="(formRoute == 'caseDetails' || formRoute == 'monitoring' || formRoute == 'underway') && this.$route.name != 'newstar'">
            <el-button type="primary" class="w200" @click="submitcase(2,true)" >确认补充信息</el-button>
        </div>
        <div v-else>
          <el-button type="primary" class="w200" @click="submitcase(1,false)" >保存案件</el-button>
            <el-button type="primary" class="w200" @click="submitcase(2,false)" >创立案件</el-button>
        </div>
        
      </div>
    </div>
    <!-- 添加 -->
    <el-dialog title="添加协调人" :visible.sync="showcooperaterDialogVisible" center top="1vh" width="1000px" @close="toggleSelection()">
      <el-table empty-text="暂无数据" :data="cooperaterData" class="mgt15" border @selection-change="handleSelectionChange"
        ref="multipleTable">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="name" label="姓名" min-width="30"></el-table-column>
        <el-table-column prop="mobileNo" label="手机号" min-width="30"></el-table-column>
        <el-table-column prop="nationalId" label="证件号码" min-width="30"></el-table-column>
      </el-table>
      <div style="text-align: center;margin-top: 10px;">
        <el-button type="primary" @click='showcooperaterDialogVisible=false;cooperaterDataList=cooperaterDataList1'>确定</el-button>
        <el-button @click='toggleSelection();showcooperaterDialogVisible=false;'>取消</el-button>
      </div>

    </el-dialog>
    <!-- 添加新注册的协调人 -->
    <el-dialog title="添加新注册的协调人" :visible.sync="addContacterDialogVisible" center top="1vh" width="600px">
      <el-form :model="addcontacterform" ref='ruleForm'>
        <el-form-item label="姓名:" :label-width="formLabelWidth" prop="name">
          <el-input v-model="addcontacterform.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" :label-width="formLabelWidth" prop="mobileNo">
          <el-input v-model="addcontacterform.mobileNo" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="证件号码:" :label-width="formLabelWidth" prop="nationalId">
          <el-input v-model="addcontacterform.nationalId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="登录名:" :label-width="formLabelWidth" prop="passport">
          <el-input v-model="addcontacterform.passport" placeholder="请输入登录名" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="登录密码:" :label-width="formLabelWidth" prop="password">
          <el-input type="password" v-model="addcontacterform.password" placeholder="请输入登录密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addSubUser">注册并添加到协调名单</el-button>
      </div>
    </el-dialog>
    <!-- 旅责险星使服务范围提示 -->
    <el-dialog title="旅责险星使服务范围提示" :visible.sync="xingshiServiceDialogVisible" center top="1vh" width="1000px">
      <h5>服务内容</h5>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content bg-purple">现在慰问、关怀</div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">案件情况核实</div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">案件处理协助</div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">治疗情况确认</div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">向导翻译服务</div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">协助联系使领馆服务</div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">证件补办协助服务</div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple" style="color:#fe893f">其他服务要求请拨打全国调处确认后发出</div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple" style="color:#fe893f">无法进行案件查勘工作</div>
        </el-col>
      </el-row>
      <h5>服务地区</h5>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple" style="text-align:left">泰国、印度尼西亚、越南、马来西亚、日本、美国、俄罗斯、柬埔寨、新加坡、菲律宾、澳大利亚、加拿大、法国、意大利、德国、瑞士、新西兰、英国、西班牙等及中国香港、澳门地区（现有星使的国家109个）</div>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="xingshiServiceDialogVisible = false">确定</el-button>
      </div>
    </el-dialog>
    <!-- GPS -->
    <div class="gpsBox" :style="{visibility:gpsBox?'initial':'hidden'}">
      <gpsBox ref='gpsBox' @getGpshid='getGpshid' @getGpshid1='getGpshid1'></gpsBox>
    </div>
    <!-- 提示有保 -->
    <el-dialog title="提示！" center :visible.sync="dialogFormVisible1" width="500px">
      <center>该出险人没有星使服务保险保障，费用将需要外部解决，是否创建星使派单？</center>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="alertyb=false;dialogFormVisible1 = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="聊天记录" center :visible.sync="dialogFormVisible2" width="800px" top="1vh">
      <chatRecord :states='1'></chatRecord>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible2 = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="创建用户作为出险人" center :visible.sync="dialogFormVisible3" width="500px">
      <div>
        <div id="">
          姓&nbsp;&nbsp;&nbsp;&nbsp;名：<el-input v-model="reportcase.victimName" placeholder="请输入姓名" style='width: 300px;'></el-input>
        </div>
        <div style="margin-top: 10px;">
          手机号：<el-input v-model="nationalMobile" placeholder="请输入姓名" style='width: 300px;'></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="newDJXid()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="案件进度" center :visible.sync="dialogFormVisible4" width="800px" top="1vh">
      <jianbao v-if='this.$route.params.caseList' :caseId1='this.$route.params.caseList.obj.id'></jianbao>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible4 = false">取 消</el-button>
        <el-button type="primary" @click="dialogFormVisible4 = false">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="创建关联案件" :visible.sync="centerDialogVisible" center top="1vh" width="1000px">
      <el-input placeholder="请输入案件编号" v-model="creatAboutText"></el-input>
      <el-button type="primary" @click='creatAboutFun'>搜索</el-button>
      <el-table empty-text="暂无数据" :data="nowCaseArr" class="mgt15" border>
        <el-table-column type="index" label="序号" min-width="30"></el-table-column>
        <el-table-column property="obj.obj.caseNo" label="案件编号" min-width="50"></el-table-column>
        <el-table-column label="用户姓名" min-width="50">
          <template slot-scope="scope">
            <span v-if="scope.row.obj.victimList.length != 0">{{scope.row.obj.victimList[0].obj.victimName}}</span>
          </template>
        </el-table-column>
        <el-table-column property="obj.obj.reporterContact" label="用户手机号" min-width="60"></el-table-column>
        <el-table-column label="证件信息" min-width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.obj.victimList.length != 0">{{scope.row.obj.victimList[0].obj.idNo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="性别" min-width="30">
          <template slot-scope="scope">
            <span v-if="scope.row.obj.victimList.length != 0">
              {{scope.row.obj.victimList[0].obj.gender == 1 ? '男':'女'}}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="出险时间" min-width="80">
          <template slot-scope="scope">
            <span>{{setTime(scope.row.obj.obj.updateAt)}}</span>
          </template>
        </el-table-column>
        <el-table-column property="obj.obj.caseSrc" label="案件类型" min-width="80">
        </el-table-column>
        <el-table-column label="操作" min-width="80">
          <template slot-scope="{ row, column, $index }">
            <el-button type="text" size="small" @click='handleAppCase1(row)'>选择此案件</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import strutils from "@/util/strutils.js";
  import constants from '@/util/constants.js';
  import { handleTokenInvalidResponse } from '@/util/auth';
  import axios from 'axios'
  import {
    creatCase,
    updataOrdinaryCase,
    addSubUser,
    listSubUser,
    searchBasic,
    creatBasic,
    listDomestic,
    getPolicies,
    getCounties,
    getallGoingCase,
    getAllCoordinatedCases,
    casecreateEditTempCase
  } from '@/views/axios/api.js';
  import changeLanguage from '@/components/common/changeLange.vue'
  import gpsBox from '@/views/map/searchMap.vue'
  import chatRecord from '@/views/cmd_center/chatRecord'
  import jianbao from '@/components/par/jianbao'
  import countries from './../js/countries.json'
  import ruserId from './ruserId'
  export default {
    data() {
      return {
        Longitudeandlatitude:'',
        fcdBtn: true,
        ifyjjy: false,
        dialogFormVisible1: false,
        dialogFormVisible2: false,
        dialogFormVisible3: false,
        dialogFormVisible4: false,
        formRoute: '',
        llrName: JSON.parse(window.localStorage.getItem("insti")),
        tableData: '',
        cooperaterData: [], //联络人表格
        cooperaterDataList: [],
        cooperaterDataList1: [],
        cooperaterCaseArr: [],
        gongzuorenyuanimageUrl: '', //跟地工作人员图片
        jiashuimageUrl: '', //患者家属
        yiliaoimageUrl: '', //医疗图片
        cailiaoimageUrl: '', //线管材料图片
        imageUrl: '', //上传图片
        addContacterDialogVisible: false, //添加新联络人
        showcooperaterDialogVisible: false, //添加
        addcontacterform: {
          name: '',
          mobileNo: '',
          nationalId: '',
          passport: '',
          password: ''
        },
        formLabelWidth: '120px',
        xingshiServiceDialogVisible: false,
        creatAboutText: '',
        initialCaseId: '',
        initialCaseIdBtn: false,
        gpsBtn: false,
        gpsBox: false,
        centerBtn: false,
        typeId: this.$route.query.typeId,
        apptodo: 0,
        apptodolst: [],
        token: JSON.parse(window.localStorage.getItem("data")).data,
        value: "",
        centerDialogVisible: false,
        gridData: [{
          xu: "1",
          code: "AJ0001",
          address: "美国纽约第五大厦",
          name: "网易黄博士",
          phone: "+86 134764787",
          info: "身份证 5454514251414",
          sex: "男",
          date: "2018年6月5日 18:00"
        }],
        domesticId: '', //国内协调人列表 GET请求参数
        reportcase: {
          token: '',
          reportUser: "",
          reportTs: "",
          reporterContact: "",
          incidentTs: "",
          caseSrc: "",
          // caseNo: "4256544",
          caseInsured: 2,
          // addr: "境内",
          nation: "+86",
          city: "",
          siteabroadExpr: '境内',
          addr: "",
          weatherIncident: 2,
          weatherTag: "",
          accidentType: "",
          victimName: "",
          insurancePolicyNo: "",
          idNo: "",
          insuranceCompanyId: '',
          injuredPart: "",
          incidentDesc: "",
          regulatorId: 1,
          incidentType: 600,
          djxId: '',
          // victimId: '',
          latitude: '',
          longitude: '',
          caseSrcDesc: '', //案件来源中英文
          gender: 1,
          initialCaseId: '', //关联的案件ID
          //汇合地点
          addr1: '境内',
          rendezvous: "",
          rlng: '',
          rlat: '1',
          rCountryCode: "+86",
          rCity: "",
          //end
          channel: '',
          channel1: '',
          travelId: '',
          subServiceType: '', //星使类型
          xsStart: '',
          xsEnd: '',
          xsDuration: '0',
          tUploadCnts: [],
          hospital: '',
          attendingDoctor: '',
          adContact: '',
          xsId: '',
          rContact: ''
        },
        travelAgency: '', //旅行社选择
        policy: null,
        companies: [{
          insti: {
            name: "江泰救援",
            id: "1"
          },
          inContract: 1
        }],
        casesrclst: [
          "一键救命",
          "电话求救",
          "保险公司转接",
          "其他",
          "保单卡报案",
          "安全中心报案"
        ],
        subServiceTypeSel: [
          "陪同就医",
          "住院案件",
          "死亡案件",
          "案件信息核实案例"
        ],
        chanelSelect: [
          "旅责险",
          "华助AA",
          "大救星救援卡",
          "其他"
        ],
        abroad: ["境内", "境外"],
        genderlst: [{
            value: 1,
            label: "男"
          },
          {
            value: 2,
            label: "女"
          }
        ],
        countries: [],
        counties: [],
        counties1: [],
        disasters: ["气象灾害", "海洋灾害", "洪水灾害", "地质灾害", "其他"],
        accidentTypes: ["意外伤害", "突发疾病", "财产损失", "道路救援"],
        tcm: [
          null,
          {
            name: "江泰救援",
            id: "1"
          }
        ],
        callCase: {
          contactName: '', //对接人
          contactNo: '', //联系方式
          company: '', //公司名称
          description: '',
          caseType: 0, //0 普通 1 咨询
          confirmed: 1, //0 待确认  1 已确认
        },
        fileObj: '',
        restaurants: '',
        nationalMobile: '',
        verifyId2: '',
        imageArr: [],
        alertyb: true,
        nowCaseArr: [],
        nowCaseArr1: [],
        ruserId: ''
      };
    },
    mounted: function() {
      this.countries = countries;
      this.loadcompanies();
      // this.loadAppCases();
      console.log(this.$route.params.caseList);
      if (this.$route.params.caseList) {
        this.handleAppCase(true, 0, true)
      }else{
        this.loadcounties();
      }
      if (this.$route.name == 'callCase1' || this.$route.name == 'newstar1') {
        this.centerBtn = true
      }
      this.getCooperaterList();
      this.getBriefList();
      this.restaurants = this.loadAll();
      this.getnowCase()
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.formRoute = from.name
      })
    },
    components: {
      changeLanguage,
      gpsBox,
      chatRecord,
      jianbao,
      ruserId
    },
    computed: {
      languageIndex() {
        return this.$store.state.language
      }
    },
    methods: {
       idnochange() {
        if(this.reportcase.idNo.length == 18) {
            var str2 = this.reportcase.idNo;
          var num = str2.charAt(16);
          //console.log(num);
          if(num%2==0){
            console.log('女');
             this.reportcase.gender = 2
          }else{
            this.reportcase.gender = 1
            console.log('男');
          }
        }
         
      },
      draft() {
         this.$router.push({
          name: "draft",
          params: {
            token: this.token
          },
          query: {
            typeId: this.typeId
          }
        });
      },
      addSubUserFun() {
        this.showcooperaterDialogVisible = true;
        setTimeout(() => {
          this.toggleSelection(this.cooperaterDataList)
        }, 500)
      },
      listDomestic(id) { //协调人
        var data = {
          token: this.token,
          start: 0,
          count: 100,
          caseId: id
        }
        listDomestic(data)
          .then(res => {
            this.cooperaterDataList = res.data.obj;
            var cooperaterDataList = []
            this.cooperaterDataList.forEach(item => {
              this.cooperaterData.forEach(item1 => {
                if (item1.id == item.id) {
                  cooperaterDataList.push(item1)
                }
              })

            })
            this.cooperaterDataList = cooperaterDataList;
            // this.toggleSelection(cooperaterDataList)
          })
          .catch(err => {
            console.log(err);
          })
      },
      loadAll() {
        var that = this;
        fetch(constants.domain + "rescue/xingshi/search_agent", {
            method: "POST",
            body: `token=${this.token}&name=`,
            mode: "cors",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          })
          .then(function(res) {
            return res.json();

          })
          .then(function(data) {
            // console.log(data.obj,'所有旅行社')
            that.restaurants = data.obj;
          })
      },
      querySearchAsync(queryString, cb) {
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;

        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          cb(results);
        }, 3000 * Math.random());
      },
      createStateFilter(queryString) {
        return (travelName) => {
          // console.log(travelName,'单车')
          return (travelName.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      setTime(str) {
        return constants.time(str)
      },
      setTxt(str, status) {
        var data=constants.setTxt(str, status)
        if (data) {
          return data
        } else {
          return str
        }
      },
      back() {
        this.$router.go(-1)
      },
      //获取国内协调人列表
      getCooperaterList() {
        var data = {
          token: this.token,
          count: 100,
          start: 0,
          all: 1
        }
        listSubUser(data)
          .then(res => {
            this.cooperaterData = res.data.obj
          })
          .catch(err => {
            console.log(err);
          })

      },
      addSubUser() {
        var that = this;
        var data = {}
        if (this.addcontacterform.name == '') {
          this.$message.error("姓名不能为空");
        } else if (this.addcontacterform.mobileNo == '') {
          this.$message.error("手机号不能为空");
        } else if (this.addcontacterform.nationalId == '') {
          this.$message.error("证件号码不能为空");
        } else if (this.addcontacterform.passport == '') {
          this.$message.error("登录名不能为空");
        } else if (this.addcontacterform.password == '') {
          this.$message.error("密码不能为空");
        } else {
          // data = this.addcontacterform;
          data = Object.assign(this.addcontacterform, {
            token: this.token
          });
          addSubUser(data)
            .then(res => {
              if (res.data.code == 0) {
                this.addContacterDialogVisible = false;
                that.getCooperaterList();
                this.$refs.ruleForm.resetFields()
              }
            })
            .catch(err => {
              console.log(err)
            })
        }

      },
      //上传图片
      handleAvatarSuccess(res, file) {
        // this.imageUrl = URL.createObjectURL(file.raw);
        // console.log(this.imageUrl)

      },
      requestFile(param) {
        // this.uploadBtn=true;
        var fileObj = param.file
        let config = {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        };
        var form = new FormData() // FormData 对象
        var token = JSON.parse(window.localStorage.getItem("data")).data
        form.append('file', fileObj) // 文件对象
        form.append('token', token) // 文件对象
        // form.append('caseId', '')
        axios.post(constants.domain + 'rescue/case/upload_file', form, config)
          .then(res => {
            console.log(res)
            if (res.data.code == 0) {
              // this.fileUrl.push(res.data.obj);
              // this.uploadBtn=false;
              if (param.action == "gongzuorenyuanimageUrl") {
                this.gongzuorenyuanimageUrl = res.data.obj;
                var gongzuorenyuanObj = {
                  "description": '跟地接社工作人员照片',
                  "objType": '15',
                  "url": res.data.obj
                };
                this.imageArr.push(gongzuorenyuanObj)
              } else if (param.action == "jiashuimageUrl") {
                this.jiashuimageUrl = res.data.obj;
                var jiashuObj = {
                  "description": '患者家属照片',
                  "objType": '16',
                  "url": res.data.obj
                };
                this.imageArr.push(jiashuObj)
              } else if (param.action == "yiliaoimageUrl") {
                this.yiliaoimageUrl = res.data.obj;
                var yiliaoObj = {
                  "description": '所在医疗机构及科室的照片',
                  "objType": '17',
                  "url": res.data.obj
                };
                this.imageArr.push(yiliaoObj)
              } else if (param.action == "cailiaoimageUrl") {
                this.cailiaoimageUrl = res.data.obj;
                var cailiaoObj = {
                  "description": '医疗证明及其他相关材料照片',
                  "objType": '18',
                  "url": res.data.obj
                };
                this.imageArr.push(cailiaoObj)
              }

            }
            // console.log(JSON.stringify(this.imageArr))
            this.reportcase.tUploadCnts = JSON.stringify(this.imageArr)
            console.log(this.reportcase.tUploadCnts)
          })
          .catch(err => {
            console.log(err)
          })
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        // if (!isJPG) {
        // this.$message.error('上传头像图片只能是 JPG 格式!');
        // }
        // if (!isLt2M) {
        // this.$message.error('上传头像图片大小不能超过 2MB!');
        // }
        // return isJPG && isLt2M;
        return true
      },
      //获取简报
      getBriefList() {
        fetch(constants.domain + "rescue/xingshi/list_brief", {
            method: "POST",
            body: `token=${this.token}&caseId=&count=10&start=1`,
            mode: "cors",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          })
          .then(function(res) {
            return res.json();

          })
          .then(function(data) {})
      },
      changeAppcase(idx) {
        this.reportcase.latitude = '';
        this.reportcase.longitude = '';

        this.reportcase.rlat = '';
        this.reportcase.rlng = '';
        this.handleAppCase(true, idx)
      },
      suoshuFun() {
        this.reportcase.regulatorId = this.reportcase.insuranceCompanyId;
      },
      genderselect() {
        if (this.reportcase.gender == "女" || this.reportcase.gender == 2) {
          this.reportcase.gender = 2;
        } else {
          this.reportcase.gender = 1;
        }
        // console.log(this.reportcase.gender + "-" + this.reportcase.gender);
      },
      //查询出险人手机号
      queryPhone() {
        var data = {
          token: this.token,
          nationalMobile: this.nationalMobile
        }
        searchBasic(data)
          .then(res => {
            console.log(res);
            if (res.data.obj == null) {
              this.$message('没有查询到您的信息，请先去创建')
            } else {
              this.reportcase.victimName = res.data.obj.realName || res.data.obj.name;

              this.reportcase.djxId = res.data.obj.id
              if (res.data.obj2.verifyId) {
                this.verifyId2 = res.data.obj2.verifyId;
              } else {
                this.verifyId2 = res.data.obj2.verifyId2;
              }
              this.reportcase.idNo = this.verifyId2
            }
          })
          .catch(err => {
            console.log(err);
          })
      },
      //查询保单
      B_queryBaodanClick() {
        if (this.reportcase.idNo == '') return this.$message.error('请输入出险人证件')
        var data = {
          token: this.token,
          hit: this.verifyId2
        }
        getPolicies(data)
          .then(res => {
            console.log(res);
            if (res.data.code == 0 && res.data.obj.length != 0) {
              this.reportcase.insurancePolicyNo = res.data.obj[0].docNo;
              this.reportcase.insuranceCompanyId = res.data.obj[0].regulatorId;
              this.reportcase.caseInsured = 1;
            } else {
              this.$message.error('未查询到，保单号码')
              this.reportcase.caseInsured = 1;
            }

          })
          .catch(err => {
            console.log(err);
          })
      },
      //创建大救星账户
      newDJXid() {
        if (this.reportcase.victimName == '') {
          return this.$message.error("创建账户时出险人姓名不能为空");
        } else if (this.nationalMobile == '') {
          return this.$message.error("创建账户时手机号不能为空")
        }
        var data = {
          token: this.token,
          name: this.reportcase.victimName,
          nationalMobile: this.nationalMobile
        }
        creatBasic(data)
          .then(res => {
            console.log(res);
            if (res.data.code == 0) {
              this.$message.success('创建成功')
              this.reportcase.djxId = res.data.obj.id
              this.dialogFormVisible3 = false
            }
          })
          .catch(err => {
            console.log(err);
          })
      },
           Longitudeandlatitudeblur() {
        if(this.Longitudeandlatitude) {
           var m = this.Longitudeandlatitude.split(",");
           console.log(m)
          this.reportcase.latitude = m[1]
          this.reportcase.longitude = m[0]
        }
         console.log(this.Longitudeandlatitude)
      },
      handleAppCase(checked, idx, params, aboutObj) {
        var z = this;
        var ow = null;
        if (params) {
          ow = this.$route.params.caseList;
          this.initialCaseIdBtn=true;
        } else {
          ow = z.apptodolst[idx];
        }
        if (aboutObj) {
          ow = aboutObj
          this.listDomestic(ow.obj.id)
          this.$refs.ruserId.getData(ow.obj.id)
        }
        if (ow.obj.initialCaseId) {
          this.initialCaseId = ow.obj.initialCaseId;
        } else {
          this.initialCaseId = ow.obj.initialCaseId;
        }
        if (checked) {
          for (var i = 0; i < z.apptodolst.length; ++i) {
            var o1 = z.apptodolst[i];
            if (i != idx) {
              o1.checked = false;
            } else {
              o1.checked = true;
            }
          }
          if (ow.helpOrder) {//回合地点
            var xsObj = ow.helpOrder
            z.reportcase.rendezvous = xsObj.rendezvous
            z.reportcase.rlng = xsObj.rlng
            z.reportcase.rlat = xsObj.rlat
            z.reportcase.rCity = xsObj.rCity
            z.reportcase.xsStart = ow.obj.xsStart
            z.reportcase.xsEnd = ow.obj.xsEnd
            z.reportcase.xsDuration = ow.obj.xsDuration
            z.reportcase.subServiceType = xsObj.subServiceType
            z.reportcase.travelId = xsObj.travelId;
            z.reportcase.channel = xsObj.channel
            z.reportcase.rContact = xsObj.rContact
            z.reportcase.xsId = xsObj.id
            z.reportcase.djxId = xsObj.userId
            z.reportcase.hospital = xsObj.hospital;
            z.reportcase.attendingDoctor = xsObj.attendingDoctor;
            z.reportcase.adContact = xsObj.adContact;
            z.reportcase.addr1 = xsObj.rCountryCode == "+86" ? "境内" : "境外";
            z.reportcase.rCountryCode = xsObj.rCountryCode || '+' + xsObj.rCity.match(/\d+(.\d+)?/g)[0];
            z.loadcounties('',false,2)
          }
          if (ow != null) {
            var o = ow.obj;

            z.reportcase.incidentId = o.id;
            z.reportcase.reportUser = o.reportUser;
            if (o.reportTs != null) z.reportcase.reportTs = o.reportTs;
            z.reportcase.reporterContact = o.reporterContact;
            if (o.incidentTs != null) {
              z.reportcase.incidentTs = o.incidentTs;
            } else {
              z.reportcase.incidentTs = new Date()
            }
            this.ifyjjy = true
            z.reportcase.caseSrc = o.caseSrc;
            z.reportcase.caseNo = o.caseNo;
            z.reportcase.caseInsured = o.caseInsured;
            if (ow.generalLocation != null) {
              var loc = ow.generalLocation;
              z.reportcase.siteabroadExpr = loc.nation == "+86" ? "境内" : "境外";
              z.reportcase.nation = loc.nation;
              console.log(z.reportcase.nation);
              z.loadcounties('',false,1)
              z.reportcase.city = loc.city;
              z.reportcase.addr = loc.addr
              z.reportcase.latitude = loc.latitude;
              z.reportcase.longitude = loc.longitude;
              console.log(z.reportcase.addr)
            } else {
              z.reportcase.siteabroadExpr = "";
              z.reportcase.nation = "";
              z.reportcase.city = "";
              z.reportcase.addr = "";
            }
            if (o.weatherIncident) {
              z.reportcase.weatherIncident = o.weatherIncident;
            }

            z.reportcase.weatherTag = o.weatherTag;
            if (o.accidentType) {
              z.reportcase.accidentType = o.accidentType;
            }


            if (ow.victimList != null && ow.victimList.length > 0) {
              var vict = ow.victimList[0].obj;
              z.reportcase.victimName = vict.victimName;
              z.reportcase.gender = vict.gender;
              z.reportcase.insurancePolicyNo = vict.insurancePolicyNo;
              z.reportcase.idNo = vict.idNo;
              if (vict.insuranceCompanyId != null) {
                z.reportcase.insuranceCompanyId = vict.insuranceCompanyId;
              } else {
                z.reportcase.insuranceCompanyId = '';
              }
              this.reportcase.djxId = ow.victimList[0].obj.djxId;
              this.reportcase.contact = ow.victimList[0].obj.contact;
              this.reportcase.insurancePaper = ow.victimList[0].obj.insurancePaper;
              z.nationalMobile = ow.victimList[0].obj.contact || ow.obj.reporterContact
            } else {
              z.reportcase.victimName = "";
              z.reportcase.gender = "";
              z.reportcase.gender = "";
              z.reportcase.insurancePolicyNo = "";
              z.reportcase.idNo = "";
              z.reportcase.insuranceCompanyId = '';
            }
            z.reportcase.regulatorId = z.reportcase.insuranceCompanyId;
            console.log(ow)
            z.reportcase.injuredPart = ow.victimList[0].obj.injuredPart;
            z.reportcase.incidentDesc = o.incidentDesc;
            z.reportcase.caseSrcDesc = o.caseSrcDesc;

            this.reportcase.victimId = ow.victimList[0].obj.id;
            // if (this.$route.name == 'callCase1' && ow.insuranceContact) {

            if (ow.insuranceContact) {
              z.reportcase.incidentDesc = ow.obj.incidentDesc;
              this.callCase.contactName = ow.insuranceContact.contactName;
              this.callCase.company = ow.insuranceContact.company;
              this.callCase.contactNo = ow.insuranceContact.contactNo;
              this.callCase.description = ow.insuranceContact.description;
            }
            if (this.reportcase.channel == '旅责险' || this.reportcase.channel == '华助AA') {

            } else {
              this.reportcase.channel1 = this.reportcase.channel
              this.reportcase.channel = '其他'
            }
          }
        }
      },
      //删除案件中的国内联络人
      handleClick(index) {
        this.cooperaterDataList.splice(index, 1)
      },
      //导入案件
      loadcounties(data1, status, id) {
        var country = '';
        if (id == 1) {
          country = this.reportcase.nation
        } else {
          country = this.reportcase.rCountryCode
        }

        var data = {
          token: this.token,
          country
        }
        console.log(data);
        getCounties(data)
          .then(res => {
            var Btn = false;
            if (!status) {
                this.counties = uniq(res.data.obj);
                this.counties1 = uniq(res.data.obj);
              return
            }
            if (id == 1) {
              this.counties = uniq(res.data.obj);
              if (data1.country == '中国') {
                this.reportcase.siteabroadExpr = '境内';
              } else {
                this.reportcase.siteabroadExpr = '境外'
              }
              if (data1.cityCode) {
                this.reportcase.city = data1.cityCode;
                this.counties.forEach(item => {
                  if (item.cityCode == data1.cityCode) {
                    Btn = true
                  }
                })
                if (!Btn) {
                  this.$message.error('未自动选择城市，请手动选择');
                  this.reportcase.city = ''
                }
              } else {
                this.$message.error('未自动选择城市，请手动选择');
                this.reportcase.city = ''
              }
            } else {
              this.counties1 = uniq(res.data.obj);
              if (data1.country == '中国') {
                this.reportcase.addr1 = '境内';
              } else {
                this.reportcase.addr1 = '境外'
              }
              if (data1.cityCode) {
                this.reportcase.rCity = data1.cityCode;
                this.counties1.forEach(item => {
                  if (item.cityCode == data1.cityCode) {
                    Btn = true
                  }
                })
                if (!Btn) {
                  this.$message.error('未自动选择城市，请手动选择');
                  this.reportcase.rCity = ''
                }
              } else {
                this.$message.error('未自动选择城市，请手动选择');
                this.reportcase.rCity = ''
              }
            }

          })
          .catch(err => {
            console.log(res);
          })
      },
      loadcompanies() {
        var z = this;
        var cmd = new Object();
        cmd.url = constants.domain + "rescue/user/list_regulator";
        cmd.data = new Object();
        cmd.data.token = this.token;
        cmd.succ = function(r) {
          z.companies = r;
          var ntcm = new Object();
          for (var i = 0; i < r.length; ++i) {
            var nt = r[i];
            ntcm[nt.insti.id] = nt;
          }
          z.tcm = ntcm;
        };
        s2c(cmd);
      },
      showinsurance() {
        if (this.policy != null) {
          window.open(this.policy.detailUrl);
        }
      },

      caseabroad(id) {
        if (id == 1) {
          if (this.reportcase.siteabroadExpr == "境内") {
            this.reportcase.nation = "+86";
          } else {
            this.reportcase.nation = "";
          }
        } else {
          if (this.reportcase.addr1 == "境内") {
            this.reportcase.rCountryCode = "+86";
          } else {
            this.reportcase.rCountryCode = "";
          }
        }
        this.loadcounties();
      },

      loadAppCases() {
        var _this = this;
        var cmd = new Object();
        cmd.url = constants.domain + "rescue/case/list_case_collection";
        cmd.data = new Object();
        cmd.data.status = 90;
        cmd.data.token = this.token;
        cmd.succ = function(r) {
          _this.apptodo = r.length;
          var rr = [];
          for (var i = 0; i < _this.apptodo; i++) {
            var o1 = r[i];
            o1.checked = false;
            _this.apptodolst.push(o1)
          }

          var index1 = ''
          if (_this.$route.params.caseId) {
            _this.apptodolst.forEach((item, index) => {
              if (item.victimList[0].obj.id == _this.$route.params.caseId) {
                index1 = index
              }
            })
            _this.changeAppcase(index1)
            console.log(_this.apptodolst[index1])
          }
        };
        s2c(cmd);

      },
      successTo() {
        this.$router.push({
          name: "ComAwait",
          params: {
            token: this.token
          },
          query: {
            typeId: this.typeId
          }
        });
      },

      submitcase(type,status) { //insuranceCompanyId
        var z = this;
        var data = {};
        if(type == 2) {
                   console.log(this.reportcase);
         if(this.$route.query.creat){//从创建关联案件过来的为创建案件
          this.initialCaseIdBtn=false
        }
        if (this.initialCaseIdBtn) {//补充案件的时候不要关联ID
          delete this.reportcase.initialCaseId//关联案件IDinitialCaseId
        }else{//创建
          this.reportcase.initialCaseId = this.initialCaseId;
          delete this.reportcase.incidentId;
          delete this.reportcase.id;
          delete this.reportcase.caseNo;
          delete this.reportcase.victimId;
          delete this.reportcase.xsId;
        }
        if (stil.judgeNull(this.reportcase.subServiceType)) {
          this.$message.error("案件类型不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reportTs)) {
          this.$message.error("报案时间不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reportUser)) {
          this.$message.error("报案人不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reporterContact)) {
          this.$message.error("报案电话不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.incidentTs)) {
          this.$message.error("出险时间不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.caseSrc)) {
          this.$message.error("案件来源不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.caseSrcDesc)) {
          this.$message.error("来源说明不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.channel)) {
          this.$message.error("渠道不能为空");
          return;
        }
        if (this.reportcase.channel == '旅责险') {
          if (stil.judgeNull(this.reportcase.travelId)) {
            this.$message.error("旅行社名称不能为空");
            return;
          }
        } else {
          if (this.reportcase.channel1 == '其他' || this.reportcase.channel == '其他') {
            this.$message.error("旅行社名称不能为空");
            return;
          }
        }

        if (
          stil.judgeNull(this.reportcase.nation) ||
          stil.judgeNull(this.reportcase.city) ||
          stil.judgeNull(this.reportcase.addr)
        ) {
          this.$message.error("出险地不能为空");
          return;
        }
        if (this.reportcase.latitude == '' || this.reportcase.longitude == '') {
          this.$message.error("出险地经纬度不能为空");
          return;
        }
        // if (this.reportcase.rlng == '' || this.reportcase.rlat == '') {
        // 	this.$message.error("汇合地点经纬度不能为空");
        // 	return;
        // }
        if (stil.judgeNull(this.reportcase.victimName)) {
          this.$message.error("出险人姓名不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.victimName)) {
          this.$message.error("出险人姓名不能为空");
          return;
        }
        if (this.reportcase.weatherIncident != 1) {
          this.reportcase.weatherTag = null;
        }
        if (!constants.setTxt(this.reportcase.addr)) {
          this.reportcase.addr = `<zh-CN>${this.reportcase.addr}</zh-CN><en-US></en-US>`;
        }
        if (!constants.setTxt(this.reportcase.incidentDesc)) {
          this.reportcase.incidentDesc = `<zh-CN>${this.reportcase.incidentDesc}</zh-CN><en-US></en-US>`;
        }
        if (!this.reportcase.djxId) {
          this.$message.error('没有检测到星使id，请查询或创建大救星账号')
          return
        }
        //电话报案
        this.reportcase.token = this.token
        this.reportcase.incidentTs = new Date(this.reportcase.incidentTs).getTime()
        this.reportcase.reportTs = new Date(this.reportcase.reportTs).getTime()
        if (this.reportcase.xsStart) {
          this.reportcase.xsStart = new Date(this.reportcase.xsStart).getTime() //起始时间
        }
        if (this.reportcase.xsEnd) {
          this.reportcase.xsEnd = new Date(this.reportcase.xsEnd).getTime()
        }
        if (this.$route.query.caseType) {
          this.reportcase.caseType = 1
        }
        this.domesticId = ''
        this.cooperaterDataList.forEach((item, index) => {
          if (index < this.cooperaterDataList.length - 1) {
            this.domesticId += 'domesticId=' + item.id + '&'
          } else {
            this.domesticId += 'domesticId=' + item.id
          }
        })
        if (this.reportcase.insurancePolicyNo) {
          this.reportcase.caseInsured = 1
        } else {
          this.reportcase.caseInsured = 2
        }
        if (this.reportcase.channel == '旅责险') {
          this.reportcase.caseInsured = 3
        }

        if (this.reportcase.caseInsured == 1 && this.alertyb) {
          this.dialogFormVisible1 = true;
          return
        }
        if (!this.fcdBtn) return this.$message('不要重复点击')
        this.fcdBtn = false
        if (this.ruserId != '') {
          this.domesticId = this.domesticId + '&' + this.ruserId
        }
        if (this.reportcase.channel == '其他') {
          this.reportcase.channel = this.reportcase.channel1
        }
        data = Object.assign(this.reportcase, this.callCase);
        if (!status) {
          creatCase(data, this.domesticId)
            .then(res => {
              if (res.data.code == 0) {
                this.$message.success('操作成功');
                if (this.$route.name == 'newstar') {
                  this.$router.push({
                    name: 'underway'
                  })
                } else {
                  this.$router.push({
                    name: 'caserecord'
                  })
                }

              }
            })
            .catch(err => {
              this.fcdBtn = true
              console.log(err)
            })
        } else {
          updataOrdinaryCase(data, this.domesticId)
            .then(res => {
              if (res.data.code == 0) {
                this.$message.success('补充信息成功')
                this.$router.go(-1)
              } else {
                this.$message.error(res.data.msg)
                this.fcdBtn = true
              }
            })
            .catch(err => {
              this.fcdBtn = true
              console.log(err)
            })
        }
        }else {
          console.log(this.reportcase);
         if(this.$route.query.creat){//从创建关联案件过来的为创建案件
          this.initialCaseIdBtn=false
        }
        if (this.initialCaseIdBtn) {//补充案件的时候不要关联ID
          delete this.reportcase.initialCaseId//关联案件IDinitialCaseId
        }else{//创建
          this.reportcase.initialCaseId = this.initialCaseId;
          delete this.reportcase.incidentId;
          delete this.reportcase.id;
          delete this.reportcase.caseNo;
          delete this.reportcase.victimId;
          delete this.reportcase.xsId;
        }
        if (stil.judgeNull(this.reportcase.subServiceType)) {
          this.$message.error("案件类型不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reportTs)) {
          this.$message.error("报案时间不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reportUser)) {
          this.$message.error("报案人不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.reporterContact)) {
          this.$message.error("报案电话不能为空");
          return;
        }
        // if (stil.judgeNull(this.reportcase.incidentTs)) {
        //   this.$message.error("出险时间不能为空");
        //   return;
        // }
        // if (stil.judgeNull(this.reportcase.caseSrc)) {
        //   this.$message.error("案件来源不能为空");
        //   return;
        // }
        // if (stil.judgeNull(this.reportcase.caseSrcDesc)) {
        //   this.$message.error("来源说明不能为空");
        //   return;
        // }
        // if (stil.judgeNull(this.reportcase.channel)) {
        //   this.$message.error("渠道不能为空");
        //   return;
        // }
        // if (this.reportcase.channel == '旅责险') {
        //   if (stil.judgeNull(this.reportcase.travelId)) {
        //     this.$message.error("旅行社名称不能为空");
        //     return;
        //   }
        // } else {
        //   if (this.reportcase.channel1 == '其他' || this.reportcase.channel == '其他') {
        //     this.$message.error("旅行社名称不能为空");
        //     return;
        //   }
        // }

        // if (
        //   stil.judgeNull(this.reportcase.nation) ||
        //   stil.judgeNull(this.reportcase.city) ||
        //   stil.judgeNull(this.reportcase.addr)
        // ) {
        //   this.$message.error("出险地不能为空");
        //   return;
        // }
        // if (this.reportcase.latitude == '' || this.reportcase.longitude == '') {
        //   this.$message.error("出险地经纬度不能为空");
        //   return;
        // }
        // if (this.reportcase.rlng == '' || this.reportcase.rlat == '') {
        // 	this.$message.error("汇合地点经纬度不能为空");
        // 	return;
        // }
        if (stil.judgeNull(this.reportcase.victimName)) {
          this.$message.error("出险人姓名不能为空");
          return;
        }
        if (stil.judgeNull(this.reportcase.victimName)) {
          this.$message.error("出险人姓名不能为空");
          return;
        }
        if (this.reportcase.weatherIncident != 1) {
          this.reportcase.weatherTag = null;
        }
        if (!constants.setTxt(this.reportcase.addr)) {
          this.reportcase.addr = `<zh-CN>${this.reportcase.addr}</zh-CN><en-US></en-US>`;
        }
        if (!constants.setTxt(this.reportcase.incidentDesc)) {
          this.reportcase.incidentDesc = `<zh-CN>${this.reportcase.incidentDesc}</zh-CN><en-US></en-US>`;
        }
        if (!this.reportcase.djxId) {
          this.$message.error('没有检测到星使id，请查询或创建大救星账号')
          return
        }
        //电话报案
        this.reportcase.token = this.token
        this.reportcase.incidentTs = new Date(this.reportcase.incidentTs).getTime()
        this.reportcase.reportTs = new Date(this.reportcase.reportTs).getTime()
        if (this.reportcase.xsStart) {
          this.reportcase.xsStart = new Date(this.reportcase.xsStart).getTime() //起始时间
        }
        if (this.reportcase.xsEnd) {
          this.reportcase.xsEnd = new Date(this.reportcase.xsEnd).getTime()
        }
        if (this.$route.query.caseType) {
          this.reportcase.caseType = 1
        }
        this.domesticId = ''
        this.cooperaterDataList.forEach((item, index) => {
          if (index < this.cooperaterDataList.length - 1) {
            this.domesticId += 'domesticId=' + item.id + '&'
          } else {
            this.domesticId += 'domesticId=' + item.id
          }
        })
        if (this.reportcase.insurancePolicyNo) {
          this.reportcase.caseInsured = 1
        } else {
          this.reportcase.caseInsured = 2
        }
        if (this.reportcase.channel == '旅责险') {
          this.reportcase.caseInsured = 3
        }

        if (this.reportcase.caseInsured == 1 && this.alertyb) {
          this.dialogFormVisible1 = true;
          return
        }
        if (!this.fcdBtn) return this.$message('不要重复点击')
        this.fcdBtn = false
        if (this.ruserId != '') {
          this.domesticId = this.domesticId + '&' + this.ruserId
        }
        if (this.reportcase.channel == '其他') {
          this.reportcase.channel = this.reportcase.channel1
        }
        data = Object.assign(this.reportcase, this.callCase);
        if (!status) {
          casecreateEditTempCase(data, this.domesticId)
            .then(res => {
              if (res.data.code == 0) {
                this.$message.success('保存成功');
                // if (this.$route.name == 'newstar') {
                //   this.$router.push({
                //     name: 'underway'
                //   })
                // } else {
                //   this.$router.push({
                //     name: 'caserecord'
                //   })
                // }

              }
            })
            .catch(err => {
              this.fcdBtn = true
              console.log(err)
            })
        } else {
          updataOrdinaryCase(data, this.domesticId)
            .then(res => {
              if (res.data.code == 0) {
                this.$message.success('补充信息成功')
                this.$router.go(-1)
              } else {
                this.$message.error(res.data.msg)
                this.fcdBtn = true
              }
            })
            .catch(err => {
              this.fcdBtn = true
              console.log(err)
            })
        }
        }
        
        
      },
      getGps(id) {
        this.gpsBox = true;
        this.$refs.changeLanguage.setBtn()
        document.getElementsByTagName("body")[0].style.height = '100vh';
        document.getElementsByTagName("body")[0].style.overflow = 'hidden';
        if (id == 1) {
          this.$refs.gpsBox.parendZx(this.reportcase.addr, id);
        } else {
          this.$refs.gpsBox.parendZx(this.reportcase.rendezvous, id);
        }

      },
      getGpshid(data, data1, id) {
        this.gpsBox = false;
        document.getElementsByTagName("body")[0].style.height = 'auto';
        document.getElementsByTagName("body")[0].style.overflow = 'auto';
        if (data.lat == '') return
        if (id == 1) {
          this.reportcase.latitude = data.lat;
          this.reportcase.longitude = data.lng;
          setTimeout(() => {
            // this.reportcase.addr = data.address;
            console.log(this.reportcase.addr);
          }, 1000)

          if (data1 == undefined) return this.$message.error('地址未自动匹配，请手动添加！');
          if (data1.country == '中国') {
            this.reportcase.nation = '+86';
          } else {
            this.countries.forEach(item => {
              if (item.label == data1.country) {
                this.reportcase.nation = item.value;
              }
            })
          }
        } else {
          this.reportcase.rlat = data.lat;
          this.reportcase.rlng = data.lng;
          setTimeout(() => {
            this.reportcase.rendezvous = data.address;
          }, 1000)
          if (data1 == undefined) return this.$message.error('地址未自动匹配，请手动添加！');
          if (data1.country == '中国') {
            this.reportcase.rCountryCode = '+86';
          } else {
            this.countries.forEach(item => {
              if (item.label == data1.country) {
                this.reportcase.rCountryCode = item.value;
              }
            })
          }
        }
        this.loadcounties(data1, true, id);
      },
      getGpshid1() {
        this.gpsBox = false;
        document.getElementsByTagName("body")[0].style.height = 'auto';
        document.getElementsByTagName("body")[0].style.overflow = 'auto';
      },
      time: constants.time,
      judgeNull: function(val) {
        return stil.judgeNull(val);
      },
      handleSelectionChange(val) {
        this.cooperaterDataList1 = val
      },
      toggleSelection(rows) {
        console.log(this.$refs);
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      getnowCase() { //当前案件管理
        var data = {
          token: this.token
        }
        var getList = null
        if (this.llrName.type == 4) {
          getList = getAllCoordinatedCases(data)
        } else {
          getList = getallGoingCase(data)
        }
        getList.then(res => {
            this.nowCaseArr = res.data.obj;
            this.nowCaseArr1 = res.data.obj;
          })
          .catch(err => {
            console.log(err)
          })
      },
      creatAboutFun() {
        if (this.creatAboutText == '') return this.nowCaseArr = this.nowCaseArr1;
        this.nowCaseArr = this.nowCaseArr.filter(item => {
          return item.obj.obj.caseNo == this.creatAboutText
        })
      },
      handleAppCase1(obj) {
        this.handleAppCase(true, 0, false, obj.obj);
        this.initialCaseIdBtn = true;
        this.centerDialogVisible = false
      },
      getRuserId(id) {
        this.ruserId = id
        console.log(id);
      }
    }
  };

  var stil = strutils;

  function forpst(obj) {
    if (stil.judgeNull(obj)) return "";
    var ks = Object.keys(obj);
    var postdata = "";
    for (var i = 0; i < ks.length; ++i) {
      var d = obj[ks[i]];
      if (d == null) continue;
      if (d.constructor == Array) {
        for (var j = 0; j < d.length; ++j) {
          postdata += ks[i] + "=" + encodeURIComponent(d[j]);
          if (j != d.length - 1) {
            postdata += "&";
          }
        }
      } else if (d.constructor == Date) {
        postdata += ks[i] + "=" + d.getTime();
      } else {
        postdata += ks[i] + "=" + encodeURIComponent(d);
      }
      if (i != ks.length - 1) {
        postdata += "&";
      }
    }
    return postdata;
  }

  function s2c(cmd) {
    fetch(cmd.url, {
        method: "POST",
        body: forpst(cmd.data),
        mode: "cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      .then(function(res) {
        //console.log(res);
        return res.json();
      })
      .then(function(data) {
        if (handleTokenInvalidResponse(data)) {
          return;
        }
        if (data.code != 0) {
          var handled = false;
          if (cmd.transerr != null) {
            handled = cmd.transerr(data.code);
          }
          if (!handled) {
            var errtxt = e2t(data.code);
            this.$message.error(errtxt);
          }
        } else {
          cmd.succ(data.obj);
        }
      });
  }

  function e2t(errcode) {
    errcode = "ERR_" + errcode;
    if ("ERR_100001" == errcode) return "参数异常，请重新提交";
    if ("ERR_101000" == errcode) return "登录过期，请重新登录";
    if ("ERR_102000" == errcode) return "用户类型错误";
    if ("ERR_102002" == errcode) return "找不到此机构";
    if ("ERR_102003" == errcode) return "合约已失效";
    if ("ERR_102004" == errcode) return "案件状态错误，无法更新";
    if ("ERR_102005" == errcode) return "案件更新失败";
    if ("ERR_102006" == errcode) return "找不到此机构";
    if ("ERR_102007" == errcode) return "机构保存错误";
    if ("ERR_102008" == errcode) return "找不到此机构合约";
    if ("ERR_102009" == errcode) return "找不到此机构收费方式";
    if ("ERR_102010" == errcode) return "合约保存错误";
    if ("ERR_102011" == errcode) return "找不到此用户";
    if ("ERR_102012" == errcode) return "此案件已创立";
    if ("ERR_101001" == errcode) return "找不到此案件";
    if ("ERR_101002" == errcode) return "找不到方案";
    if ("ERR_101003" == errcode) return "您没有操作权限，请联系管理员";
    if ("ERR_102000" == errcode) return "找不到当前操作状态";
    if ("ERR_101004" == errcode) return "找不到案件出险人";
    if ("ERR_101010" == errcode) return "找不到此方案对应的服务清单";
    if ("ERR_101005" == errcode) return "此案件未推送机构";
    if ("ERR_101006" == errcode) return "救援机构尚未提交方案";
    if ("ERR_101007" == errcode) return "此案已审核，不能修改";
    if ("ERR_101008" == errcode) return "请勿重新提交方案";
    if ("ERR_101009" == errcode) return "找不到此上传资源，无法修改";
    if ("ERR_100000" == errcode) return "未知错误";
    return errcode;
  }

  function uniq(array) {
    var temp = [];
    var index = [];
    var l = array.length;
    for (var i = 0; i < l; i++) {
      for (var j = i + 1; j < l; j++) {
        if (array[i].cityCode == array[j].cityCode) {
          i++;
          j = i;
        }
      }
      temp.push(array[i]);
      index.push(i);
    }
    return temp;
  }
</script>

<style scoped>
  @import url("./../style.css");

  /* @import url("./js/elementUI/index.css"); */
  .avatar-uploader .el-upload {

    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .uploadStyle {
    margin-top: 15px;
    margin-left: 10px;
  }

  .uploadStyle span {
    float: left;
    width: 110px;
    font-size: 14px;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .serviceBrief ul li h4 {
    border-bottom: 1px solid #eee;
    width: 200px;
    line-height: 24px;
  }

  .serviceBrief ul li h4 small {
    margin-left: 35px;
  }

  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple {
    background: #f5f5f5;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    margin-top: 10px;
    text-align: center;
    line-height: 36px;
    min-height: 36px;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

  input.el-input__inner {
    height: 30px !important;
    line-height: 30px !important;
  }

  td {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .margint10 {
    padding-top: 10px;
  }

  .marginl10 .contactAddStyle {
    cursor: pointer;
    margin-left: 30px;
    float: right;
    font-size: 13px;
    color: #484646;
    font-weight: 400;
  }

  .marginl10 .contactAddStyle::before {
    content: '+';
    color: #00ABF9;
    width: 15px;
    height: 15px;
    display: inline-block;
    border-radius: 7.5px;
    text-align: center;
    line-height: 15px;
    font-size: 16px;
    margin-right: 5px;
    border: 1px solid #00ABF9;
  }

  .el-input,
  .el-select {
    width: 50%;
  }

  .el-input__inner,
  .el-input--suffix {
    width: 100%;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 50%;
  }

  .lisave {
    font-size: 10px;
    color: #399cff;
    cursor: pointer;
  }

  .w140 {
    width: 140px;
  }

  .w213 {
    width: 213px;
  }

  .w120 {
    width: 120px;
  }

  .f10 {
    font-size: 10px;
  }

  .w75 {
    width: 75px;
  }

  .w130 {
    width: 130px;
  }

  .w303 {
    width: 303px;
    display: inline-block;
  }

  .w88100 {
    width: 88%;
    display: inline-block;
  }

  .w200 {
    width: 200px;
  }

  .mgt5 {
    margin-top: 5px;
  }

  .mgt15 {
    margin-top: 15px;
  }

  .p1026 {
    padding: 10px 26px;
  }

  .h50 {
    height: 50px;
    line-height: 50px;
  }

  .span_node {
    font-weight: normal;
    font-size: 14px;
  }

  .w100 {
    width: 100px;
  }

  .app-aj div {
    padding: 0;
    margin: 10px 0;
  }

  .lianluo {
    overflow: hidden;
    font-size: 14px;
    margin-top: 20px;
    padding: 0 15px;
  }

  .lianluo li {
    float: left;
    width: 50%;
  }

  .lianluo li .must {
    color: red;
  }

  .marginCenter {
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    position: relative;
    padding-top: 20px;
  }

  .blue {
    color: #00ABF9;
    cursor: pointer;
  }

  .gpsBox {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: powderblue;
    overflow: hidden;
  }

  .back {
    background: url(./../images/back.png) left center no-repeat;
    padding-left: 20px;
    background-size: 15px;
    cursor: pointer;
    position: absolute;
    top: 10px;
    left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/star/newstar.vue